import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA }
	from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';

import { SaveDraftFeedback } from '../../models/save-draft-feedback';

@Component({
	selector: 'copo-snackbar-save-draft',
	templateUrl: './snackbar-save-draft.component.html',
	styleUrl: './snackbar-save-draft.component.css',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [NgIf, MatButtonModule, TranslateModule]
})
export class SnackbarSaveDraftComponent {
	constructor(
		private readonly snackBarRef: MatSnackBarRef<SnackbarSaveDraftComponent>,
		private readonly router: Router,
		@Inject(MAT_SNACK_BAR_DATA) public data: SaveDraftFeedback
	) {}

	dismiss() {
		this.snackBarRef.dismiss();
	}

	getData() {
		return this.data;
	}

	async navigateToDraftListView() {
		this.snackBarRef.dismiss();
		const url = this.getData().redirectUrl;
		if (url) {
			await this.router.navigateByUrl(url);
		}
	}

	showFeedback() {
		return this.data.hideResponseDetails;
	}
}
